import ExtrasRouter from '@/components/pages/extra/index.vue';
import Extras from '@/components/pages/extra/Extras.vue';

export default {
  path: '/extras',
  name: 'ExtrasRouter',
  component: ExtrasRouter,
  children: [
    {
      path: '/extras',
      component: Extras,
      name: 'Extras',
      meta: {
        acceptRoles: ['admin'],
      },
    },
  ],
}
